import { render, staticRenderFns } from "./ShopifyFlowEvents.vue?vue&type=template&id=70690ada&scoped=true"
import script from "./ShopifyFlowEvents.vue?vue&type=script&lang=ts"
export * from "./ShopifyFlowEvents.vue?vue&type=script&lang=ts"
import style0 from "./ShopifyFlowEvents.vue?vue&type=style&index=0&id=70690ada&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70690ada",
  null
  
)

export default component.exports